import cx from 'classnames'
import s from './new-badge.module.scss'

type Props = {
  className?: string
}

// Small "New" pill used to flag newly launched nav items (e.g. Shop). Text-only,
// following the featured-/most-popular-badge house pattern.
export const NewBadge = ({ className }: Props) => {
  return <span className={cx(s.newBadge, className)}>New</span>
}
